/* eslint-disable semi */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  Collapse,
  Row,
  Col,
} from 'reactstrap';

class SampleJsonModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSections: {
        rfid: false,
        data: true,
        bp: false,
      },
    };
  }

  toggleSection = key => {
    this.setState(prevState => ({
      openSections: {
        ...prevState.openSections,
        [key]: !prevState.openSections[key],
      },
    }));
  };

  render() {
    const { isOpen, toggle } = this.props;
    const { openSections } = this.state;

    const json = {
      rfid: {
        masterdata_id: 'string',
        group: 'string',
        value: {
          id: 'string',
          rule: 'number',
          name: 'string',
          quota: 'number',
        },
      },
      transaction: {
        product: {
          quantity: 'number',
          device_id: 'string',
          price: 'number',
          name: 'string',
          location: 'string',
          sku: 'string',
        },
        devices: {},
        detail: {
          transaction_status: 'string',
          order_id: 'string',
        },
        time: {
          firestore_timestamp: 'Timestamp',
          timestamp: 'number',
        },
        payment: {
          amount: 'number',
          method: 'string',
          nett: 'number',
          fee: {
            platform_sharing_revenue: 'number',
            mdr_qris: 'number',
          },
          detail: {
            transaction_id: 'string',
            transaction_status: 'string',
            transaction_time: 'string',
            order_id: 'string',
            issuer: 'string',
            id: 'string',
          },
        },
      },
      bp: {
        sn: 'string',
        pic: 'string',
        cp: 'string',
        email: 'string',
        address: 'string',
        tags: 'string',
        created_date: 'timestamp (number)',
        active_date: 'timestamp (number)',
        vmcode: 'string',
        device_id: 'string',
        refiller: 'string',
        loc: {
          _latitude: 'number',
          _longitude: 'number',
        },
        type: 'string',
        name: 'string',
      },
    };

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="xl">
        <ModalHeader toggle={toggle}>Contoh Struktur Data</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              {/* Data Transaksi */}
              <Card className="mb-3">
                <Button color="link" onClick={() => this.toggleSection('data')}>
                  ▶ Struktur: <strong>transaction</strong>
                </Button>
                <Collapse isOpen={openSections.data}>
                  <CardBody>
                    <pre>{JSON.stringify(json.transaction, null, 2)}</pre>
                  </CardBody>
                </Collapse>
              </Card>
            </Col>
            <Col>
              {/* Data BP */}
              <Card>
                <Button color="link" onClick={() => this.toggleSection('bp')}>
                  ▶ Struktur: <strong>bp</strong>
                </Button>
                <Collapse isOpen={openSections.bp}>
                  <CardBody>
                    <pre>{JSON.stringify(json.bp, null, 2)}</pre>
                  </CardBody>
                </Collapse>
              </Card>
            </Col>
            <Col>
              {/* Data RFID */}
              <Card className="mb-3">
                <Button color="link" onClick={() => this.toggleSection('rfid')}>
                  ▶ Struktur: <strong>rfid</strong>
                </Button>
                <Collapse isOpen={openSections.rfid}>
                  <CardBody>
                    <pre>{JSON.stringify(json.rfid, null, 2)}</pre>
                  </CardBody>
                </Collapse>
              </Card>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Tutup
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default SampleJsonModal;
